/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/secret';
import { SECRET } from '@/store/types';
import { finalizeAction, ActionType } from '@/store/actions';

export interface StoreSecretTopsMetaState {
  game: string;
  meta: api.SecretTopMeta;
  type: string;
  tabs: api.SecretTopMeta;
}

export default {
  namespaced: true,
  state: {
    meta: null,
    type: null,
    tabs: null,
  },
  getters: {},
  actions: {
    [SECRET.GET_TOPS_META]({ state, commit }, { action: rawAction = '' }: {action?: ActionType} = {}) {
      const action = finalizeAction(rawAction, state.meta);
      if (action) {
        return new Promise((resolve, reject) => {
          api.getTopsMeta().then((res) => {
            commit(SECRET.GET_TOPS_META, {
              meta: res.data,
            });
            resolve(state.meta);
          }).catch(reject);
        });
      }
      return Promise.resolve(state.meta);
    },
    [SECRET.GET_TOPS_TABS]({ state, commit }, { type, action: rawAction }) {
      const action = finalizeAction(rawAction, state.tabs && state.type === type);
      if (action) {
        return new Promise((resolve, reject) => {
          api.getTopsTabs(type).then((res) => {
            commit(SECRET.GET_TOPS_TABS, {
              type,
              tabs: res.data,
            });
            resolve(state.tabs);
          }).catch(reject);
        });
      }
      return Promise.resolve(state.tabs);
    },
  },
  mutations: {
    [SECRET.GET_TOPS_META](state, { meta }) {
      state.meta = meta;
    },
    [SECRET.GET_TOPS_TABS](state, { type, tabs }) {
      state.type = type;
      state.tabs = tabs;
    },
  },
};
